var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigibyte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#002352"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.659 17.2455H21.1695C21.1695 17.2455 24.107 17.2174 22.0755 21.0871C22.0755 21.0871 20.593 24.1156 16.9143 24.0595L18.8991 18.8893C18.9471 18.764 18.9321 18.6227 18.8589 18.5109C18.7856 18.3991 18.6635 18.3309 18.5318 18.3284L15.926 18.283L12.6316 26.4711C12.6316 26.4711 13.7297 26.5833 14.3337 26.5272L14.0042 27.3684H15.5608C15.6483 27.3683 15.7266 27.3129 15.7574 27.2293L16.0358 26.4711L16.6946 26.415L16.3103 27.3684H17.8257C17.9385 27.3684 18.0398 27.2978 18.081 27.1906L18.5071 26.0785C18.5071 26.0785 23.1192 25.2934 25.2057 21.4797C25.2057 21.4797 28.0059 17.0492 24.7115 15.4789C24.0695 15.1782 23.3829 14.9887 22.68 14.918L23.0676 13.95C23.0914 13.8905 23.0846 13.8228 23.0495 13.7694C23.0143 13.7161 22.9554 13.6841 22.8925 13.6842H21.4715L21.0323 14.862H20.4283L20.7693 13.9472C20.7915 13.8875 20.7835 13.8205 20.748 13.768C20.7125 13.7154 20.6539 13.6841 20.5914 13.6842H19.1638L18.7245 14.862H14.2887C14.0453 14.8612 13.8216 14.9984 13.7077 15.2181L12.659 17.2455Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigibyte);
export default __webpack_public_path__ + "static/media/digibyte.32e87d7906a70cfd17a987f2e0cb9b07.svg";
export { ForwardRef as ReactComponent };